import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 16, className = "" }) {
  const rounded = Math.round(value);
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= rounded ? "fill-ochre-400 text-ochre-400" : "fill-none text-sand-300"}
        />
      ))}
    </span>
  );
}
